import { useState } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import "./App.css";
import { useDispatch, useSelector } from "react-redux";
import Draggable from "react-draggable";

import Protected from "./Protected.js";

import LoginPage from "./pages/LoginPage";
import Logout from "./pages/Logout";
import ValidatePage from "./pages/utils/ValidatePage";
import PathNotResolved from "./pages/PathNotResolved.js";

import { UserTabsProvider } from "./pages/cn/components/common/UserTabsContext.jsx";
import IncommingAudioCall from "./pages/cn/components/draggableCall/IncommingAudioCall.jsx";
import CoachCallAudio from "./pages/cn/components/draggableCall/CoachCallAudio.jsx";
import ApiInsight from "./pages/cn/dashboard/ApiInsight.jsx";

import MemberConnectAgentLayout from "./pages/componenents/Layout/MemberConnect/MemberConnectAgentLayout.js";
import ContentCallHistory from "./pages/componenents/ContentMemberEngagement/ContentCallHistory.js";
import ContentCallHistoryAgent from "./pages/componenents/ContentMemberEngagement/ContentCallHistoryAgent.js";

import ConfigurationSettingsAgentCalls from "./pages/met/configurationsettings/ConfigurationSettingsAgentCalls.js";
import SettingDispositionAgent from "./pages/met/components/SettingDispositionAgent.js";
import MemberRegisterLaterPage from "./pages/met/registerLater/MemberRegisterLaterPage.js";
import MemberManagement from "./pages/met/usermanagement/UserManagementPage.js";
import MemberEngagementPage from "./pages/met/engagementpage/MemberEngagementPage.js";
import ContentAgentReports from "./pages/met/Reports/ContentAgentReports.js";
import MemberConfigurationListPage from "./pages/met/configuration/MemberConfigurationListPage.js";
import MemberConnectAgent from "./pages/met/memberconnect/MemberConnectAgent.js";
import MemberCommunications from "./pages/met/membercommunication/MemberCommunications.js";
import MemberAdminWAAnalytics from "./pages/met/AnalyticsWhatsAppMembers/MemberAdminWAAnalytics.jsx";

import ConnectInbox from "./pages/met/MemberConnectInbox/ConnectInbox.jsx";

import ContentAddMemberManagement from "./pages/met/components/ContentAddNewUser.js";
import ContentEditMemberManagement from "./pages/met/components/ContentEditUserMangement.js";
import ContentMemberReenrollDetails from "./pages/met/reenroll/ContentMemberReenrollDetails.js";
import ProritizePool from "./pages/met/prioritizepool/ProritizePool.js";
import ProritizePoolList from "./pages/met/prioritizepool/ProritizePoolList.js";

import ConfigurationSettingsCareNavigatorCalls from "./pages/met/configurationsettings/ConfigurationSettingsCareNavigatorCalls.js";

import MemberEngagmentChallengePage from "./pages/met/challenges/MemberEngagmentChallengePage.js";

import HccReports from "./pages/hcc/Pages/Reports/HccReports.js";
import NoAccess from "./pages/NoAccess.js";
import ContentCallDispositionDetails from "./pages/componenents/ContentMemberEngagement/ContentCallDispositionDetails.js";
import MemberProfileMC from "./pages/met/memberconnect/MemberProfileMC.js";
import BulkAddMemberManagement from "./pages/met/usermanagement/BulkAddMemberManagement.js";

function App() {
  const webex = useSelector((state) => state.webex);
  let id = useCnID();
  const dispatch = useDispatch();

  // incomming call
  const [shouldShowIncomming, setShouldShowIncomming] = useState(false);
  const [isAcceptedCall, setIsAcceptedCall] = useState(false);
  const [inConfNumber, setInconfNumber] = useState(null);
  const [cnID, setCnID] = useState(id);
  const [incommingMemberName, setIncommingMemberName] = useState("");
  const [incommingAgentName, setIncommingAgentName] = useState("");
  const [incommingMemberId, setIncommingMemberId] = useState("");

  // outgoing call
  const [showCallBlock, setShowCallBlock] = useState(false);
  const [showDisposition, setShowDisposition] = useState(false);
  const [outgoingCallMemberInfo, setOutGoingCallMemberInfo] = useState({
    userId: "",
    memberName: "",
    mobile: "",
    callId: null,
    callType: "",
    nonScheduled: "",
    cnId: "",
  });

  // close the call window
  function changeCallBlockDisplayStatus(status) {
    setShowCallBlock(status);
  }

  // trigger disposition
  function triggerDisposition() {
    setShowDisposition(true);
  }

  return (
    <>
      {showCallBlock && (
        <Draggable bounds="body">
          <div className="box-draggable">
            <CoachCallAudio
              userId={outgoingCallMemberInfo.userId}
              memberName={outgoingCallMemberInfo.memberName}
              changeCallBlockDisplayStatus={changeCallBlockDisplayStatus}
              triggerDisposition={triggerDisposition}
              mobileNo={outgoingCallMemberInfo.mobile}
              extensionNo={outgoingCallMemberInfo.extension}
              callId={outgoingCallMemberInfo.callId}
              nonScheduled={outgoingCallMemberInfo.nonScheduled}
              cnId={outgoingCallMemberInfo.cnId}
            />
          </div>
        </Draggable>
      )}

      {webex.isIncommingCall && (
        <Draggable bounds="body">
          <div className="box-draggable">
            <IncommingAudioCall
              incommingConfNumber={inConfNumber}
              isAcceptedCall={isAcceptedCall}
              memberName={incommingMemberName}
              agentName={incommingAgentName}
              setIsAcceptedCall={setIsAcceptedCall}
              setShouldShowIncomming={setShouldShowIncomming}
              incommingMemberId={incommingMemberId}
              cnId={cnID}
              callerInfo={webex.callerInfo}
            />
          </div>
        </Draggable>
      )}
      <UserTabsProvider>
        <Routes>
          <Route path="/">
            {/* Starts Common */}
            <Route exact path="/" element={<Navigate to="/login" />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/logout" element={<Logout />} />
            <Route path="/validate" element={<ValidatePage />} />

            <Route
              path="/no-access"
              element={<NoAccess />}
              title="Invalid Request"
            />
            <Route path="/api-insight" element={<ApiInsight />} />
            <Route path="*" element={<PathNotResolved />} />
            {/* Ends Common */}

            
            {/* Member Connect Agent Routes */}
            <Route element={<MemberConnectAgentLayout />}>
              <Route
                path="/member-connect"
                element={
                  <Protected
                    Component={MemberConnectAgent}
                    title="Member Connect Agent"
                    pathNew="member-connect"
                  />
                }
              />
              <Route
                path="/member-insight-agent"
                element={
                  <Protected
                    Component={ContentCallHistoryAgent}
                    title="Member Engagement (Phase 1)"
                    pathNew="member-insight-agent"
                  />
                }
              />
              <Route
                path="/member-whatsapp-analytics"
                element={
                  <Protected
                    Component={MemberAdminWAAnalytics}
                    title="Member WhatsApp Analytics"
                    pathNew="member-whatsapp-analytics"
                  />
                }
              />
            </Route>

            {/* End member connect agent routes */}

            {/* Starts MemberConnect */}
            <Route
              path="/member-insight"
              element={
                <Protected
                  Component={ContentCallHistory}
                  title="Member Engagement (Phase 1)"
                  pathNew="member-insight"
                />
              }
            />
            <Route path="/member-insight-agent" element={<Protected Component={ContentCallHistoryAgent} title='Member Engagement (Phase 1)' pathNew="member-insight-agent" />} />
            <Route
              path="/member-engagement"
              element={
                <Protected
                  Component={MemberEngagementPage}
                  title="Member Engagement"
                  pathNew="member-engagement"
                />
              }
            />
            <Route
              path="/member-inbox-agent"
              element={
                <Protected
                  Component={ConnectInbox}
                  title="Member Engagement (Phase 1)"
                  pathNew="member-inbox-agent"
                />
              }
            />
            <Route
              path="/register-later"
              element={
                <Protected
                  Component={MemberRegisterLaterPage}
                  title="Member De-Enrollment"
                  pathNew="register-later"
                />
              }
            />
            <Route
              path="/member-configuration"
              element={
                <Protected
                  Component={MemberConfigurationListPage}
                  title="Member Engagement"
                  pathNew="member-configuration"
                />
              }
            />
            <Route
              path="/membercommunications"
              element={
                <Protected
                  Component={MemberCommunications}
                  title="Member Communications"
                  pathNew="member-communications"
                />
              }
            />
            <Route
              path="/agent-reports"
              element={
                <Protected
                  Component={ContentAgentReports}
                  title="Agent Reports"
                  pathNew="agent-reports"
                />
              }
            />
            <Route
              path="/call-setting"
              element={
                <Protected
                  Component={ConfigurationSettingsAgentCalls}
                  title="Configuration Settings Agent Calls"
                  pathNew="call-setting"
                />
              }
            />
            <Route
              path="/setting-disposition-agent"
              element={
                <Protected
                  Component={SettingDispositionAgent}
                  title="Setting Disposition Agent"
                  pathNew="setting-disposition-agent"
                />
              }
            />
            <Route
              path="/member-management"
              element={
                <Protected
                  Component={MemberManagement}
                  title="Member Management"
                  pathNew="member-management"
                />
              }
            />
            <Route
              path="/hcc-reports"
              element={
                <Protected
                  Component={HccReports}
                  title="Reports"
                  pathNew="hcc-reports"
                />
              }
            />

            <Route
              path="/call-setting"
              element={
                <Protected
                  Component={ConfigurationSettingsAgentCalls}
                  title="Configuration Settings Agent Calls"
                  pathNew="call-setting"
                />
              }
            />
            <Route
              path="/member-challenges"
              element={
                <Protected
                  Component={MemberEngagmentChallengePage}
                  title="Member Challenges"
                  pathNew="member-challenges"
                />
              }
            />
            <Route
              path="/member-call-disposition"
              element={
                <Protected
                  Component={ContentCallDispositionDetails}
                  title="Member Call Disposition"
                  pathNew="member-call-disposition"
                />
              }
            />
            <Route
              path="/member-call-history"
              element={
                <Protected
                  Component={ContentCallHistory}
                  title="Member Call History"
                  pathNew="member-call-history"
                />
              }
            />
            <Route
              path="/member-management"
              element={
                <Protected
                  Component={MemberManagement}
                  title="Member Management"
                  pathNew="member-management"
                />
              }
            />
            <Route
              path="/add-new-member"
              element={
                <Protected
                  Component={ContentAddMemberManagement}
                  title="Add New Member"
                  pathNew="add-new-member"
                />
              }
            />
            <Route
              path="/edit-new-member/:userId"
              element={
                <Protected
                  Component={ContentEditMemberManagement}
                  title="Edit New Member"
                  pathNew="edit-new-member"
                />
              }
            />

            <Route
              path="/mc-member-profile"
              element={
                <Protected
                  Component={MemberProfileMC}
                  title="Member Journey"
                  pathNew="mc-member-profile"
                />
              }
            />

            <Route
              path="/call-settings-care-navigator-calls"
              element={
                <Protected
                  Component={ConfigurationSettingsCareNavigatorCalls}
                  title="Configuration Settings for Care Navigator Calls"
                  pathNew="call-settings-care-navigator-calls"
                />
              }
            />
            <Route
              path="/setting-disposition-agent"
              element={
                <Protected
                  Component={SettingDispositionAgent}
                  title="Setting Disposition Agent"
                  pathNew="setting-disposition-agent"
                />
              }
            />
            <Route
              path="/register-later"
              element={
                <Protected
                  Component={MemberRegisterLaterPage}
                  title="Member De-Enrollment"
                  pathNew="register-later"
                />
              }
            />
            <Route
              path="/agent-reports"
              element={
                <Protected
                  Component={ContentAgentReports}
                  title="Agent Reports"
                  pathNew="agent-reports"
                />
              }
            />
            <Route
              path="/reenroll-details"
              element={
                <Protected
                  Component={ContentMemberReenrollDetails}
                  title="Member Re-enroll"
                  pathNew="reenroll-details"
                />
              }
            />
            <Route
              path="/proritize-pool"
              element={
                <Protected
                  Component={ProritizePool}
                  title="Proritize Pool"
                  pathNew="proritize-pool"
                />
              }
            />
            <Route
              path="/proritize-pool-list"
              element={
                <Protected
                  Component={ProritizePoolList}
                  title="Upload File Checker"
                  pathNew="proritize-pool-list"
                />
              }
            />
            <Route
              path="/proritize-pool-list"
              element={
                <Protected
                  Component={ProritizePoolList}
                  title="Upload File Checker"
                  pathNew="proritize-pool-list"
                />
              }
            />
            {/* Ends MemberConnect */}
          </Route>
        </Routes>
      </UserTabsProvider>
    </>
  );
}

export default App;

// custom hook for getting cnid
export function useCnID() {
  const careNavigatorID = localStorage.getItem("cnId");
  return careNavigatorID;
}
